import * as moment from "moment";

export function diffDays(date) {
    moment.lang('es');
    let mdate = moment(date);
    return moment().diff(mdate, 'days');
};